const fr = {

    // Navigation
    home: 'Accueil',
    marketplace: 'Marketplace',
    products: 'Produits',
    login: 'Connexion',
    logout: 'Déconnexion',
    register: 'S\'inscrire',
    myAccount: 'Mon Compte',
    adminPanel: 'Panneau Admin',
    cart: 'Panier',
    
    // Hero Section
    heroTitle: 'Plateforme Numérique #1 des Caraïbes',
    heroSubtitle: 'Achetez des cartes-cadeaux, des recharges de jeux, des abonnements et des services numériques avec livraison instantanée',
    heroSlide2Title: 'Livraison Numérique Instantanée',
    heroSlide2Subtitle: 'Recevez vos codes immédiatement après le paiement',
    heroSlide3Title: 'Meilleurs Prix Garantis',
    heroSlide3Subtitle: 'Les prix les plus compétitifs pour tous les produits numériques',
    exploreProducts: 'Explorer les Produits',
    shopNow: 'Acheter',
    downloadApp: 'Télécharger l\'app',
    installApp: 'Installer l\'app',
    installAppHint: 'Pour installer : ouvrez le menu Chrome (⋮), puis touchez « Installer l\'application » ou « Ajouter à l\'écran d\'accueil ».',
    appInstalledToast: 'KayiCom est installée. Ouvrez-la depuis votre écran d\'accueil !',
    apkDownloadStarted: 'Téléchargement de l\'APK. Ouvrez le fichier puis installez-le.',
    appUpdateTitle: 'Mise à jour disponible',
    appUpdateMessage: 'Une nouvelle version de KayiCom est prête. Mettez à jour pour les dernières corrections et fonctionnalités.',
    appUpdateLater: 'Plus tard',
    appUpdateNow: 'Mettre à jour',
    appUpdateInstalling: 'Téléchargement de la mise à jour…',
    appUpdatePermission: 'Autorisez KayiCom à installer des mises à jour, puis réessayez.',
    appUpdateFailed: 'Échec de la mise à jour. Réessayez.',
    appUpdateManualHint: 'Ouvrez cette page dans Chrome, téléchargez, puis installez le nouvel APK KayiCom une fois. Les prochaines mises à jour s\'installeront depuis l\'app.',
    appUpdateVersionLine: 'Vous avez v{local} → v{remote}',
    appUpdatePlayProtectHint: 'Si Play Protect bloque l\'installation, choisissez Installer quand même.',
    getStarted: 'Commencer',
    
    // Features
    instantDelivery: 'Livraison Instantanée',
    instantDeliveryDesc: 'Codes livrés en quelques secondes',
    securePayment: 'Paiement Sécurisé',
    securePaymentDesc: 'Transactions protégées',
    support247: 'Support 24/7',
    support247Desc: 'Aide quand vous en avez besoin',
    competitivePrice: 'Prix Compétitifs',
    competitivePriceDesc: 'Meilleur rapport qualité-prix',
    
    // Homepage
    bestsellerLabel: 'Meilleures ventes',
    bestSellingProducts: 'Produits les Plus Vendus',
    categoryDeals: 'Offres Spéciales',
    viewAll: 'Voir Tout',
    latestBlogPosts: 'Derniers Articles',
    visitBlog: 'Visiter le Blog',
    salesCount: 'vendus',
    noProductsAvailable: 'Aucun produit disponible',
    totalProducts: 'Produits',
    totalSales: 'Ventes',
    totalCategories: 'Catégories',

    // Blog
    blog: 'Blog',
    blogSubtitle: 'Guides, annonces et conseils sur les produits numériques et le streaming',
    blogFeatured: 'À la une',
    readMore: 'Lire la suite',
    readArticle: 'Lire l\'article',
    backToBlog: 'Retour au blog',
    loadingPosts: 'Chargement des articles...',
    loadingPost: 'Chargement de l\'article...',
    noBlogPosts: 'Aucun article publié pour le moment.',
    postNotFound: 'Cet article n\'est pas disponible.',
    minRead: 'min de lecture',
    relatedArticles: 'Articles similaires',
    allArticles: 'Tous les articles',

    // Products
    allProducts: 'Tous les Produits',
    productsSubtitle: 'Trouvez les meilleures offres numériques instantanément.',
    noProductsInCategory: 'Aucun produit disponible dans cette catégorie',
    noProductsYet: 'Aucun produit pour le moment.',
    showingResultsFor: 'Résultats pour',
    itemsCount: 'articles',
    allCategories: 'Tout',

    // Top-Up
    topupHeroTitle: 'Recharge de Jeux',
    topupHeroSubtitle: 'Rechargez Free Fire LATAM et Delta Force — livré instantanément sur votre compte.',
    topupPlayerVerify: 'Vérification du Player ID',
    topupPlayerVerifyDesc: 'Nous vérifions votre ID avant la livraison',
    topupAutoDelivery: 'Livraison Automatique',
    topupAutoDeliveryDesc: 'Crédits livrés en quelques minutes',
    browseByGame: 'Parcourir par Jeu',
    allGames: 'Tous les Jeux',
    otherGames: 'Autres Jeux',
    howItWorks: 'Comment ça Marche',
    topupStep1: 'Choisissez votre jeu et forfait',
    topupStep2: 'Choisissez un forfait et entrez votre Player ID',
    topupStep3: 'Payez en sécurité et recevez instantanément',
    topupIdDialogDesc: 'Entrez votre ID en jeu pour continuer. Obligatoire pour la livraison.',
    topupSelectPackage: 'Choisissez un forfait',
    topupPackages: 'forfaits',
    topupBuy: 'Acheter',
    topupOfficialBadge: 'Recharge officielle',
    topupProductSubtitle: 'Choisissez un forfait et rechargez votre compte !',
    topupVerifyPlayerId: 'Vérifier le Player ID',
    topupSelected: 'Forfait sélectionné',
    topupSearchGames: 'Rechercher un jeu...',
    topupPopularGames: 'Populaires',
    topupSelectGame: 'Choisissez votre jeu',
    topupInstantBadge: 'Instantané',
    topupPopularSection: 'Populaires',
    topupDirectSection: 'Recharge directe',
    topupBestSellers: 'Nos meilleures ventes',
    topupBestSellerBadge: 'Best-seller',
    topupBrowseAll: 'Tous les forfaits',
    topupStepEnterId: 'Entrez votre Player ID',
    topupSelectTopUp: 'Choisissez le forfait',
    topupContinueCheckout: 'Continuer vers le paiement',
    topupViewAll: 'Voir tout',
    topupTrending: 'Tendances',
    backToGames: 'Retour aux jeux',
    playerName: 'Nom du joueur',
    fromPrice: 'À partir de',
    noTopupPackages: 'Aucun forfait trouvé pour ce jeu.',
    viewGamePage: 'Ouvrir la page du jeu',

    // Subscriptions
    subscriptionHeroTitle: 'Abonnements Premium',
    subscriptionHeroSubtitle: 'Netflix, Spotify, Disney+, YouTube Premium et plus — activés rapidement à des prix imbattables.',
    subscriptionInstantDesc: 'Accès livré en quelques minutes',
    subscriptionRenewLabel: 'Formules flexibles',
    subscriptionRenewDesc: 'Choisissez la durée qui vous convient',
    subscriptionStep1: 'Choisissez votre abonnement et sa durée',
    subscriptionStep2: 'Payez en toute sécurité avec votre méthode préférée',
    subscriptionStep3: 'Recevez vos accès et profitez-en',
    editPlayerId: 'Modifier le Player ID',
    saveAndContinue: 'Enregistrer et Continuer',
    playerIdRequired: 'Le Player ID est obligatoire',
    idSaved: 'ID enregistré',
    verifyingId: 'Vérification...',
    idVerified: 'ID vérifié',
    floatingAnnouncementLabel: 'Annonce',
    floatingAnnouncementDismiss: 'Compris',

    // NatCash payment
    natcashPaymentTitle: 'Paiement NatCash',
    natcashAccountName: 'Nom du compte',
    natcashPhone: 'Numéro NatCash',
    natcashAmount: 'Montant à envoyer',
    natcashReference: 'Code de référence (mettre dans Contenu)',
    natcashWaitingPayment: 'En attente de paiement',
    natcashHowToPay: 'Comment payer avec NatCash :',
    natcashStep1: 'Composez *202# sur votre téléphone',
    natcashStep2: 'Choisissez Transfert',
    natcashStep3: 'Entrez le montant exact indiqué ci-dessus',
    natcashStep4: 'Dans le champ Contenu, entrez le code de référence indiqué ci-dessus',
    natcashStep5: 'Entrez votre code secret NatCash',
    natcashStep6: 'Appuyez sur Envoyer pour payer',
    natcashPhoneWarning: 'Le numéro depuis lequel vous envoyez doit correspondre à celui utilisé lors de la commande.',
    natcashVerifyNow: 'VÉRIFIER MAINTENANT',
    natcashSmsCountdown: 'En attente du SMS',
    natcashAutoCheck: 'Le système vérifie automatiquement toutes les 10 secondes',
    natcashAutoPayHint: 'Envoyez le montant exact et mettez le code de référence dans Kontni — confirmation automatique.',
    natcashVerifying: 'Vérification...',
    natcashCopy: 'COPIER',
    natcashCopied: 'Copié !',
    natcashAutoPayment: 'Paiement automatique — NatCash/Natcom',
    natcashTotalHtg: 'Total NatCash (HTG)',
    paymentConfirmed: 'Paiement confirmé !',
    paymentConfirmedPreparingDelivery: 'Paiement confirmé. Nous préparons votre livraison. Rouvrez cette page pour la consulter.',
    autoDeliveryPendingHint: 'Votre commande a été reçue et est en cours de traitement. Merci de patienter pendant que nous finalisons la livraison.',

    transcodeLabel: 'Transcode',
    transcodePayHint: 'Payez le montant exact ci-dessus, puis collez le Transcode reçu par SMS ci-dessous.',
    moncashPayHint: 'Payez le montant exact avec votre numéro MonCash (509 + 8 chiffres) — confirmation automatique à partir de votre numéro et du montant, aucun Transcode requis.',
    moncashOrderCreated: 'Commande créée ! Payez le montant exact avec votre numéro MonCash — confirmation automatique à partir de votre numéro et du montant.',
    moncashTopupCreated: 'Recharge créée ! Payez le montant exact avec votre numéro MonCash — confirmation automatique à partir de votre numéro et du montant.',
    transcodeSmsNote: 'Après le paiement, NatCash vous envoie un SMS de confirmation. Le Transcode se trouve dans ce message — copiez-le et collez-le dans le champ ci-dessous.',
    transcodePlaceholder: 'ex. 26082105770513',
    transcodeEnterHint: 'Entrez le Transcode reçu par SMS NatCash',
    transcodeVerify: 'Vérifier montant + Transcode',
    transcodeVerifying: 'Vérification montant + Transcode…',
    transcodeApproved: 'Paiement confirmé.',

    // MonCash payment
    moncashAutoPayment: 'Paiement MonCash automatique (HTG)',
    moncashMinPurchase: 'Achat minimum',
    moncashNeedMore: 'il vous manque',
    moncashNeedMoreSuffix: '',
    moncashFee: 'Frais MonCash',
    natcashFee: 'Frais NatCash',
    htgPaymentFee: 'Frais de paiement',
    moncashFeeOnOrder: 'sur cette commande',
    moncashMinimum: 'Minimum MonCash',
    moncashTotalWithFee: 'Total avec frais',
    moncashAmountToPay: 'Montant à payer sur MonCash',
    moncashMerchantPhone: 'Numéro MonCash',
    moncashPayerPhone: 'Numéro depuis lequel vous devez envoyer',
    moncashToPay: 'Montant à payer',
    moncashPayWith: 'Payer avec MonCash',
    moncashAutoConfirm: 'Confirmation automatique après le paiement MonCash',
    moncashOpenPayment: 'Ouvrir le paiement MonCash',
    moncashIPaidVerify: 'J’ai payé — Vérifier',
    moncashChecking: 'Vérification…',
    moncashLinkMissing: 'Lien de paiement MonCash manquant',
    moncashVerifyFailed: 'Impossible de vérifier le paiement MonCash',
    moncashPaymentConfirmed: 'Paiement MonCash confirmé !',
    moncashPaymentPending: 'Paiement encore en attente',
    moncashRedirecting: 'Redirection vers MonCash...',
    moncashContinueOnTracking: 'Commande créée ! Continuez le paiement MonCash sur la page de suivi.',
    moncashMinPurchaseIs: 'L’achat minimum MonCash est de',
    moncashMinShort: 'Min MonCash',
    moncashOrderTotal: 'Total de la commande',
    plopplopUssdOption: 'Payer par invite USSD sur votre téléphone MonCash — sans page de redirection',
    plopplopUssdHint: 'Une invite USSD MonCash a été envoyée sur votre téléphone. Approuvez-la, puis attendez la confirmation et la livraison automatiques.',
    plopplopUssdNoPromptHint: 'Aucune invite USSD n’est envoyée si le solde e-money MonCash est insuffisant, ou si le numéro est NatCash.',
    plopplopUssdResend: 'Renvoyer l’invite USSD',
    plopplopUssdResent: 'Une nouvelle invite USSD MonCash a été demandée. Approuvez-la sur le même téléphone.',
    plopplopUssdResendFailed: 'Impossible de renvoyer l’invite USSD',
    ussdPayPageTitle: 'Paiement MonCash USSD',
    ussdPayPageHint: 'Appuyez sur Payer pour envoyer l’invite USSD. Le système vérifie automatiquement. Vous pouvez aussi appuyer sur J’ai payé.',
    ussdPayButton: 'Payer',
    ussdIPaidButton: 'J’ai payé',
    ussdTxnFromSms: 'Numéro de transaction MonCash du SMS',
    ussdTxnFromSmsHint: 'Si « J’ai payé » ne trouve pas le paiement, saisissez le numéro de transaction du SMS MonCash, puis réessayez.',
    ussdPaySent: 'Invite USSD envoyée. Approuvez-la sur votre téléphone MonCash.',
    ussdPayWaiting: 'En attente de la confirmation automatique…',
    plopplopPhoneLabel: 'Numéro de téléphone MonCash',
    plopplopPhoneRequired: 'Entrez un numéro MonCash valide (39308318)',
    plopplopRedirectHint: 'Terminez le paiement sur la page sécurisée. Cet écran se met à jour automatiquement, puis la commande est livrée.',
    plopplopCardTitle: 'Carte débit / crédit',
    plopplopCardDesc: 'Payer par carte en toute sécurité (USD). Vos informations sont envoyées automatiquement.',
    plopplopCardHint: 'Terminez le paiement par carte. Le montant est débité en USD. Cet écran se met à jour automatiquement, puis la commande est livrée.',
    plopplopCardRedirecting: 'Redirection vers le paiement par carte (USD)…',
    plopplopOpenCardPayment: 'Continuer le paiement par carte',
    plopplopOpenHostedPayment: 'Continuer le paiement',
    plopplopPaymentExpired: 'Ce paiement a expiré après 10 minutes. Passez une nouvelle commande pour payer.',
    plopplopCardAmountHtg: 'Total carte (USD)',
    plopplopCardFee: 'Frais carte',
    plopplopCardPayUsd: 'Débité en USD',
    plopplopCardAutoConfirm: 'Le paiement est confirmé automatiquement après le règlement.',
    paymentDescription: 'Description du paiement',
    playerFound: 'Joueur trouvé',
    
    // Categories
    categoryTitle: 'Catégories de Produits',
    giftCards: 'Cartes-Cadeaux',
    gameTopup: 'Recharge de Jeux',
    subscriptions: 'Abonnements',
    services: 'Services',
    crypto: 'Crypto',
    
    // What We Offer
    whatWeOffer: 'Ce Que Nous Offrons',
    offerSubtitle: 'Choisissez parmi plusieurs catégories de produits numériques avec livraison immédiate',
    internationalGiftCards: 'Cartes-Cadeaux Internationales',
    giftCardsDesc: 'Amazon, Google Play, iTunes, Steam et plus',
    automaticGameTopup: 'Recharge de Jeux Automatique',
    gameTopupDesc: 'Free Fire LATAM et Delta Force - livraison instantanée',
    premiumSubscriptions: 'Abonnements Premium',
    subscriptionsDesc: 'Netflix, Spotify, Disney+ et autres services',
    digitalServices: 'Services Numériques',
    servicesDesc: 'Créer compte Stripe, vérifier PayPal, TextNow',
    
    // Featured Products
    featuredProducts: 'Produits en Vedette',
    buyNow: 'Acheter Maintenant',
    addToCart: 'Ajouter au Panier',
    viewDetails: 'Voir les Détails',
    available: 'Disponible',
    outOfStock: 'Épuisé',
    
    // Ready to Start
    readyToStart: 'Prêt à Commencer?',
    
    // Auth
    email: 'Email',
    password: 'Mot de Passe',
    fullName: 'Nom Complet',
    confirmPassword: 'Confirmer le Mot de Passe',
    dontHaveAccount: 'Vous n\'avez pas de compte?',
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    createAccount: 'Créer un Compte',
    gmailYahooOnly: 'Utilisez une adresse Gmail ou Yahoo pour créer un compte.',
    verifyEmailSent: 'Compte créé. Vérifiez votre e-mail pour continuer.',
    verifyEmailToContinue: 'Vérifiez votre e-mail pour continuer. Nous vous avons envoyé un lien.',
    verifyEmailTitle: 'Vérifiez votre e-mail',
    verifyEmailMissingToken: 'Ouvrez le lien de vérification dans votre e-mail, ou renvoyez-le.',
    verifyEmailBanner: 'Vérifiez votre e-mail pour passer votre première commande.',
    resendVerification: 'Renvoyer l’e-mail de vérification',
    rememberMe: 'Se souvenir de moi',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    forgotPassword: 'Mot de passe oublié?',
    orContinueWith: 'ou continuer avec',
    continueWithGoogle: 'Continuer avec Google',
    continueWithTelegram: 'Continuer avec Telegram',
    socialLoginStateInvalid: 'Session sociale expirée. Veuillez réessayer.',
    securityCheck: 'Vérification de sécurité',
    securityCheckHint: 'Résolvez cette addition pour prouver que vous êtes humain.',
    enterResult: 'Entrez le résultat',
    solveSecurityCheck: 'Veuillez résoudre la vérification de sécurité',
    refresh: 'Actualiser',
    resetPassword: 'Réinitialiser le mot de passe',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    backToLogin: 'Retour à la connexion',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    resetLinkSent: 'Si l\'email existe, un lien de réinitialisation a été envoyé.',
    resetSuccess: 'Mot de passe réinitialisé. Veuillez vous connecter.',
    tokenMissing: 'Jeton de réinitialisation manquant ou invalide.',
    
    // Cart & Checkout
    yourCart: 'Votre Panier',
    emptyCart: 'Votre panier est vide',
    continueShopping: 'Continuer les Achats',
    orderSummary: 'Résumé de la Commande',
    subtotal: 'Sous-total',
    total: 'Total',
    items: 'articles',
    checkout: 'Passer la Commande',
    placeOrder: 'Passer la Commande',
    
    // Payment
    paymentMethod: 'Méthode de Paiement',
    cryptocurrency: 'Cryptomonnaie (Automatique)',
    manualPayment: 'Paiement Manuel',
    cryptoDesc: 'Bitcoin, Ethereum, et plus',
    manualDesc: 'Virement bancaire, autres méthodes (preuve requise)',
    
    // Order Tracking
    orderTracking: 'Suivi de Commande',
    orderNumber: 'Commande',
    orderStatus: 'Statut de la Commande',
    paymentStatus: 'Statut du Paiement',
    orderItems: 'Articles de la Commande',
    submitProof: 'Soumettre la Preuve de Paiement',
    transactionId: 'ID de Transaction',
    proofUrl: 'URL de la Preuve',
    uploadProof: 'Télécharger la Preuve',
    
    // Dashboard
    dashboard: 'Tableau de Bord',
    myOrders: 'Mes Commandes',
    totalOrders: 'Total Commandes',
    pendingOrders: 'Commandes en Attente',
    completedOrders: 'Commandes Complétées',
    noOrders: 'Vous n\'avez pas encore de commandes',
    
    // Admin
    manageProducts: 'Gérer les Produits',
    manageOrders: 'Gérer les Commandes',
    siteSettings: 'Paramètres du Site',
    addProduct: 'Ajouter un Produit',
    editProduct: 'Modifier le Produit',
    deleteProduct: 'Supprimer le Produit',
    productName: 'Nom du Produit',
    description: 'Description',
    category: 'Catégorie',
    price: 'Prix',
    currency: 'Devise',
    imageUrl: 'URL de l\'Image',
    stockAvailable: 'Stock Disponible',
    deliveryType: 'Type de Livraison',
    automatic: 'Automatique',
    manual: 'Manuel',
    save: 'Enregistrer',
    cancel: 'Annuler',
    
    // Settings
    general: 'Général',
    apiKeys: 'Clés API',
    appearance: 'Apparence',
    siteName: 'Nom du Site',
    supportEmail: 'Email de Support',
    logoUrl: 'URL du Logo',
    primaryColor: 'Couleur Primaire',
    secondaryColor: 'Couleur Secondaire',
    saveSettings: 'Enregistrer les Paramètres',
    
    // Footer
    aboutUs: 'À Propos',
    contact: 'Contact',
    footerCompany: 'Entreprise',
    footerCategories: 'Catégories',
    footerSocial: 'Réseaux',
    footerBlogs: 'Blog',
    footerTagline:
      'Cartes-cadeaux, recharges de jeux, abonnements et services numériques, livrés rapidement.',
    footerSocialComingSoon: 'Retrouvez-nous bientôt sur les réseaux sociaux.',
    quickLinks: 'Liens Rapides',
    support: 'Support',
    refundPolicy: 'Politique de remboursement',
    privacyPolicy: 'Politique de confidentialité',
    amlPolicy: 'Politique LBC',
    legalPagesNav: 'Mentions légales',
    legalOnThisPage: 'Sur cette page',
    allRightsReserved: 'Tous droits réservés',
    
    // Messages
    loading: 'Chargement...',
    processing: 'Traitement...',
    success: 'Succès!',
    error: 'Erreur',
    loginSuccess: 'Connexion réussie!',
    logoutSuccess: 'Déconnexion réussie!',
    productAdded: 'Produit ajouté au panier',
    productRemoved: 'Produit retiré du panier',
    orderPlaced: 'Commande passée avec succès!',
    proofSubmitted: 'Preuve de paiement soumise avec succès!',

    myWallet: 'Mon Portefeuille',
    withdrawBalance: 'Solde Retirable',
    pendingBalance: 'Solde en Attente',
    consumableBalance: 'Solde Consommable',
    withdraw: 'Retirer',
    recharge: 'Recharger',
    topUpWallet: 'Recharger le Portefeuille',
    amountUsd: 'Montant (USD)',
    enterAmount: 'Entrez le montant',
    toPayHtg: 'À payer : {amount} HTG',
    confirm: 'Confirmer',
    creditsBalance: 'Solde Crédits',
    creditsRateHint: '1000 crédits = 1,00 $',
    creditsPlaceholder: 'Crédits',
    convert: 'Convertir',
    transactionsTab: 'Transactions',
    topupsTab: 'Recharges',
    noTransactionsYet: 'Aucune transaction',
    noTopupsYet: 'Aucune recharge',
    topupDetails: 'Détails de la Recharge',
    close: 'Fermer',
    selectTopupDetails: 'Sélectionnez une recharge pour voir les détails.',
    walletCredited: 'Portefeuille crédité avec succès.',
    paidCrediting: 'Payé — crédit en cours...',
    openPlisioInvoice: 'Ouvrir la Facture Plisio',
    cryptoInvoiceAuto: 'Votre facture crypto devrait s\'ouvrir automatiquement.',
    iPaidVerifyCrypto: 'J\'ai payé — Vérifier crypto',
    cryptoAutoCheck: 'Vérification automatique toutes les 10 secondes après paiement.',
    verifying: 'Vérification...',
    errorLoadingWallet: 'Erreur de chargement du portefeuille',
    enterValidAmount: 'Entrez un montant valide',
    enterCreditsMultiple: 'Entrez des crédits (multiple de 1000)',
    creditsMustBeMultiple: 'Les crédits doivent être un multiple de 1000',
    convertedCreditsSuccess: 'Converti {credits} crédits → {amount}',
    errorConvertingCredits: 'Erreur de conversion des crédits',
    redirectingCryptoPayment: 'Redirection vers le paiement crypto...',
    cryptoNotAvailable: 'Paiement crypto indisponible — clé Plisio non configurée',
    topupCreatedTranscode: 'Recharge créée — payez et entrez votre Transcode ci-dessous.',
    topupCreatedAuto: 'Recharge créée — paiement vérifié automatiquement',
    errorCreatingTopup: 'Erreur lors de la création de la recharge',
    paymentConfirmedWallet: 'Paiement confirmé ! Portefeuille crédité.',
    cryptoNotConfirmedYet: 'Paiement crypto pas encore confirmé',
    plisioVerifyFailed: 'Échec de la vérification Plisio',
    cryptoAuto: 'Crypto (Automatique)',
    natcashAuto: 'NatCash (Auto)',
    moncashAuto: 'MonCash (Auto)',
    binancePayAuto: 'Binance Pay (Auto)',
    balance: 'Solde',
    points: 'Points',
    sellerCenter: 'Espace Vendeur',
    sellerApplication: 'Candidature Vendeur',
    becomeSeller: 'Devenir Vendeur',
    purchasedOrders: 'Commandes Achetées',
    mySubscriptions: 'Mes Abonnements',
    coupon: 'Coupon',
    referral: 'Parrainage',
    messages: 'Messages',
    disputes: 'Litiges',
    helpCenter: 'Centre d\'Aide',
    notification: 'Notifications',
    termsConditions: 'Conditions Générales',
    termsContactHeading: 'Contact',
    termsContactText: 'Des questions sur ces conditions ? Écrivez-nous à',
    customerIdCopied: 'ID client copié',
    couldNotCopy: 'Impossible de copier',
    customer: 'Client',
    pendingBadge: 'En attente',
    activeBadge: 'actif',
    newBadge: 'nouveau',
    filterAll: 'Tout',
    filterPending: 'En attente',
    filterProcessing: 'En cours',
    filterCompleted: 'Terminé',
    filterCancelled: 'Annulé',
    orderHash: 'Commande #{id}',
    itemsLabel: 'articles',
    startShopping: 'Commencer les Achats',
    noOrdersYet: 'Aucune commande',
    oneYear: '1 An',
    month: 'Mois',
    months: 'Mois',
    paymentMethodCryptocurrency: 'Cryptomonnaie',
    paymentMethodBinancePay: 'Binance Pay (Auto)',
    paymentMethodBinanceManual: 'Binance Pay (Manuel)',
    mustLoginToContinue: 'Vous devez vous connecter pour continuer',
    walletBalanceTitle: 'Solde Portefeuille',
    clickLoadWalletBalance: 'Cliquez pour charger le solde',
    balanceAmount: 'Solde : {amount}',
    insufficientWalletBalance: 'Solde insuffisant. Rechargez votre portefeuille.',
    topUpWalletBtn: 'Recharger le portefeuille',
    cryptoCheckoutDesc: 'Bitcoin, Ethereum, USDT - Livraison instantanée',
    binancePay: 'Binance Pay',
    autoVerified: 'Vérification auto',
    cashApp: 'Cash App',
    cashAppManualDesc: 'Vérification manuelle — soumettez la preuve après paiement',
    sendTo: 'Envoyer à :',
    playerIdsRequired: 'Player ID requis',
    playerIdFor: '{label} pour {product}',
    enterYourLabel: 'Entrez votre {label}',
    playerIdsSaved: 'Player IDs',
    accountCredentialsRequired: 'Identifiants de compte requis',
    enterField: 'Entrez {field}',
    couponCode: 'Code Coupon',
    enterCoupon: 'Entrez le coupon',
    apply: 'Appliquer',
    applying: 'Application...',
    clear: 'Effacer',
    couponApplied: 'Coupon appliqué',
    couponActive: 'Coupon actif pour cette commande.',
    minOrderForCoupon: 'Commande minimum pour ce coupon : {amount}',
    discount: 'Réduction',
    secureTransaction: 'Transaction sécurisée',
    fastDelivery: 'Livraison rapide',
    mustLoginBeforePurchase: 'Connectez-vous avant d\'acheter',
    cartEmpty: 'Votre panier est vide',
    enterPlayerIdFirst: 'Entrez d\'abord un Player ID',
    playerIdVerified: 'Player ID vérifié !',
    invalidPlayerId: 'Player ID invalide',
    verificationFailed: 'Échec de la vérification. Réessayez.',
    redirectingPayment: 'Redirection vers le paiement...',
    orderCreatedTranscode: 'Commande créée ! Payez avec MONCASH/NATCASH et entrez votre Transcode sur la page de commande.',
    paidWithWallet: 'Payé avec le portefeuille !',
    orderCreatedSubmitProof: 'Commande créée ! Soumettez votre preuve de paiement.',
    errorCreatingOrder: 'Erreur lors de la création de la commande',
    sessionExpiredLogin: 'Votre session a expiré. Reconnectez-vous puis réessayez le paiement.',
    enterCouponCode: 'Entrez un code coupon',
    invalidCoupon: 'Coupon invalide',
    autoLabel: 'Auto',
};

export default fr;
